import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 71px;
  height: 30px;
  font-family: 'Basier Circle';
  clear: both;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 49px;
  padding: 6px;
  font-weight: 500;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  font-size: 12px;
  letter-spacing: -0.2px;
  color: #000000;

  cursor: pointer;

  :hover {
    border-color: #000;
  }

  @media only screen and (device-width: 375px) and (max-height: 896px) {
    text-align: center !important;
    font-size: 13px;
    padding: 3px;
    font-weight: 500;
    margin-left: 8px;
  }
`;

function RemoveButton(props) {
  return <Container onClick={props.onClick}>{props.children}</Container>;
}

export default RemoveButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/RemoveButton/index.jsx